import { Box } from '@mui/material';
import type { MetricRegistryMeta } from '../types';
import CatalogIdBadge from './CatalogIdBadge';
import CopyMetricQueryButton from './renderers/CopyMetricQueryButton';
import MetricInfoButton from './MetricInfoButton';

type Props = {
  query?: string;
  registry?: MetricRegistryMeta | null;
  /** `corner` = absolute top-right on tiles; `inline` = beside title in sticky modal headers. */
  placement?: 'corner' | 'inline';
  showCatalogId?: boolean;
};

/** Tile chrome: top-right MetricInfo + query copy; bottom-right CatalogId (RBAC). */
export default function TileMetaActions({
  query,
  registry,
  placement = 'corner',
  showCatalogId = true,
}: Props) {
  const actionButtons = (
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <MetricInfoButton registry={registry} />
      <CopyMetricQueryButton query={query} />
    </Box>
  );
  const catalogId = showCatalogId ? <CatalogIdBadge registry={registry} /> : null;

  if (placement === 'inline') {
    return (
      <>
        {actionButtons}
        {catalogId}
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {actionButtons}
      </Box>
      {catalogId}
    </>
  );
}
